/* @ngInject */
function WorkflowCalendarController ($scope, $rootScope, $state, $timeout, $q, $location, $translate, UdsModalService, TasksService, BoardsService, Utils, SegmentService, WorkflowHeaderService) {
  const getRequestDetailsDialogController = () => $q.when(import('../../dialogs/request-details/request-details-dialog.controller'))

  $scope.weekDays = [
    { label: 'weekDays-short.0', value: 'SUNDAY' },
    { label: 'weekDays-short.1', value: 'MONDAY' },
    { label: 'weekDays-short.2', value: 'TUESDAY' },
    { label: 'weekDays-short.3', value: 'WEDNESDAY' },
    { label: 'weekDays-short.4', value: 'THURSDAY' },
    { label: 'weekDays-short.5', value: 'FRIDAY' },
    { label: 'weekDays-short.6', value: 'SATURDAY' }
  ]

  $scope.flags = {
    loadingCalendar: false,
    refreshDays: null
  }

  $scope.filters = {
    isArchived: false,
    showOcculted: false
  }
  $scope.searchTerm = ''

  const today = moment()
  const todayDay = moment().format('DD')
  const todayMonth = moment().format('MM')
  const todayYear = moment().format('YYYY')
  let month

  const quickFilters = {
    assignees: null,
    authors: null,
    overdue: false
  }

  $scope.todayNumber = parseInt(moment().format('D'))

  const api = {
    getRequestDetailsDialogController,
    _buildCalendar,
    _checkIfTaskIsLate,
    _defineCardWidth,
    _doDataFlow,
    _setWorkingDays,
    _defineIfIsWorkingDay,
    _handleChangeFilters,
    _calendarDeliveryDateColor,
    _getHeaderInfo,
    _onFilter,
    _onQuickFilters,
    _handleQuickFilter
  }
  this.getApi = () => api

  activate()

  function activate () {
    const url = $location.search()
    $scope.boardId = url.board

    $rootScope.getUser().then(user => {
      if (!$rootScope.isUserSysAdminAdminDesigner(user)) {
        $state.go('workflow.requests')
      }
    })

    if (!url.board) {
      $state.go('workflow.home')
      return
    }

    if (url.term) {
      $scope.searchTerm = url.term
    }

    $scope.taskWidth = api._defineCardWidth()

    $scope.showCurrentDate = true
    $scope.year = today.format('YYYY')

    month = today.format('M')

    api._doDataFlow()
    TasksService.getRequestsCount().then(count => { $scope.requestsCount = count })
  }

  $scope.onSearchTasks = (searchTerm) => {
    $scope.searchTerm = searchTerm
    const url = $location.search()

    if (searchTerm) {
      $location.search({ ...url, term: searchTerm })
    } else {
      $location.search({ ...url, term: null })
    }

    api._buildCalendar()

    SegmentService.track('workflow-search', { place: $state.current.name, board: $scope.boardId, search_text: searchTerm })
  }

  const deregisterOnBoardChange = $scope.$on('workflow-board-updated', (evt, data) => {
    $scope.board = data.board
  })

  const deregisterReopenCreateTaskDialog = $scope.$on('workflow.reopenCreateTaskDialog', (event, data) => {
    WorkflowHeaderService.openCreateTaskDialog(data?.createMore)
  })

  $scope.$on('$destroy', () => {
    deregisterOnBoardChange()
    deregisterReopenCreateTaskDialog()
  })

  $scope.showPrevMonth = function () {
    $scope.showCurrentDate = false
    if (month === 1) {
      month = 12
      $scope.year--
    } else {
      month--
    }
    api._buildCalendar()
  }

  $scope.goToInbox = () => {
    const params = {
      from: $location.url()
    }

    $location.path('/workflow/requests').search(params)
  }

  function _calendarDeliveryDateColor (deliveryDate) {
    const daysDifference = Utils.daysUntilDelivery(deliveryDate)
    if (daysDifference === 1) {
      return daysDifference
    }
  }

  $scope.showNextMonth = function () {
    $scope.showCurrentDate = false
    if (month === 12) {
      month = 1
      $scope.year++
    } else {
      month++
    }
    api._buildCalendar()
  }

  $scope.showCurrentDateClick = function () {
    $scope.showCurrentDate = true
    $scope.year = today.format('YYYY')
    month = today.format('M')
    api._buildCalendar()
  }

  $scope.openBoardsPage = function () {
    $scope.$emit('workflow.changeToBoards')
  }

  $scope.openTaskDetails = function (id) {
    api.getRequestDetailsDialogController().then(({ RequestDetailsDialogController }) => {
      const modal = UdsModalService.createModal({
        controller: RequestDetailsDialogController,
        modalName: 'requestDetailsDialog',
        data: {
          id
        },
        onClose: (info) => {
          if (info?.wasUpdated) {
            api._buildCalendar()
          }
        }
      })
      modal.open()
    })
  }

  $scope.showAllClick = function (day) {
    day.showMoreTasks = !day.showMoreTasks
  }

  function _buildCalendar () {
    api._setWorkingDays()
    const date = new Date(parseInt($scope.year), parseInt(month) - 1, 1)
    const firstDayOfMonth = moment(date).format('d') // on week days

    $scope.monthName = moment(date).format('MMMM')

    const lastDayOfPrevMonth = moment(date).subtract(1, 'days').format('D')
    const prevMonth = moment(date).subtract(1, 'days').format('MM')

    TasksService.getCalendarTasks(moment(date).format('YYYY-MM-DD'), $scope.boardId, $scope.filters, $scope.searchTerm).then(tasks => {
      const lastMonthTasks = []
      const thisMonthTasks = []
      const nextMonthTasks = []

      tasks.forEach(task => {
        const info = task.deliveryDate.split('-')
        task.day = info[2]

        if (info[1] === prevMonth) {
          api._checkIfTaskIsLate(task)
          lastMonthTasks.push(task)
        } else if (info[1] === moment(date).format('MM')) {
          api._checkIfTaskIsLate(task)
          thisMonthTasks.push(task)
        } else {
          api._checkIfTaskIsLate(task)
          nextMonthTasks.push(task)
        }
      })

      // add days from prev month, if needed
      $scope.days = []
      if (firstDayOfMonth > 0) {
        for (let i = firstDayOfMonth - 1; i >= 0; i--) {
          const tasks = lastMonthTasks.filter(item => parseInt(item.day) === lastDayOfPrevMonth - i)
          const lateTasks = tasks.some(item => item.late)
          $scope.days.push({
            number: lastDayOfPrevMonth - i,
            tasks,
            lateTasks,
            showMoreTasks: false
          })
        }
      }

      // add days from current month
      const numberOfDays = moment(`${parseInt($scope.year)}-${parseInt(month)}`, 'YYYY-MM').daysInMonth()
      for (let i = 1; i <= numberOfDays; i++) {
        const tasks = thisMonthTasks.filter(item => parseInt(item.day) === i)
        const lateTasks = tasks.some(item => item.late)
        let nextDay = false
        if (tasks[0]) {
          nextDay = api._calendarDeliveryDateColor(tasks[0].deliveryDate)
        }

        const dayDate = new Date(parseInt($scope.year), parseInt(month) - 1, i)
        const dayOfWeek = moment(dayDate).format('d')

        const day = {
          number: i,
          thisMonth: true,
          tasks,
          lateTasks,
          nextDay,
          showMoreTasks: false,
          isWorkingDay: true
        }

        api._defineIfIsWorkingDay(day, dayOfWeek)

        $scope.days.push(day)
      }

      // add days from next month, if needed
      if ($scope.days.length === 42 || $scope.days.length === 35 || $scope.days.length === 28) {
        $scope.flags.loadingCalendar = false
        $scope.flags.refreshDays = new Date().toISOString()
        return
      }
      let daysToAdd
      if ($scope.days.length < 35) {
        daysToAdd = 35 - $scope.days.length
      } else if ($scope.days.length < 42) {
        daysToAdd = 42 - $scope.days.length
      }

      for (let i = 1; i <= daysToAdd; i++) {
        const tasks = nextMonthTasks.filter(item => parseInt(item.day) === i)
        const lateTasks = tasks.some(item => item.late)
        $scope.days.push({
          number: i,
          tasks,
          lateTasks,
          showMoreTasks: false
        })
      }
      $scope.flags.loadingCalendar = false
      $scope.flags.refreshDays = new Date().toISOString()

      $timeout(() => {
        $('.day-tooltip').popup()
      }, 100, false)
    })
  }

  function _checkIfTaskIsLate (task) {
    const info = task.deliveryDate.split('-')

    if (task.status !== 'DONE') {
      if (info[0] < todayYear) {
        task.late = true
      } else if (info[0] === todayYear) {
        if (info[1] < todayMonth) {
          task.late = true
        } else if (info[1] === todayMonth) {
          if (task.day < todayDay) {
            task.late = true
          }
        }
      }
    }
  }

  function _defineCardWidth () {
    const container = document.querySelector('.calendar-content')
    const computedStyle = window.getComputedStyle(container)
    const width = Number.parseInt(computedStyle.width) - 8

    return width / 7 - 32
  }

  function _doDataFlow () {
    $scope.flags.loadingCalendar = true

    BoardsService.getBoardById($scope.boardId)
      .then(board => {
        $scope.board = board
        api._getHeaderInfo(board)
      })
      .then(api._buildCalendar)
  }

  function _setWorkingDays () {
    if ($scope.board.workingDays) {
      $scope.weekDays.forEach(day => {
        day.isWorkingDay = $scope.board.workingDays.includes(day.value)
      })
    }
  }

  function _defineIfIsWorkingDay (day, weekDayNumber) {
    let weekDay

    switch (parseInt(weekDayNumber)) {
      case 0:
        weekDay = 'SUNDAY'
        break
      case 1:
        weekDay = 'MONDAY'
        break
      case 2:
        weekDay = 'TUESDAY'
        break
      case 3:
        weekDay = 'WEDNESDAY'
        break
      case 4:
        weekDay = 'THURSDAY'
        break
      case 5:
        weekDay = 'FRIDAY'
        break
      case 6:
        weekDay = 'SATURDAY'
        break
    }

    if (!$scope.board.workingDays.includes(weekDay)) {
      day.isWorkingDay = false
    }
  }

  function _handleChangeFilters () {
    api._buildCalendar()
  }

  function _getHeaderInfo (board) {
    $scope.headerNavigation = WorkflowHeaderService.getHeaderNavigation(board)
    WorkflowHeaderService.getHeaderToolbar($translate, board, { onSearch: $scope.onSearchTasks, onFilter: api._onFilter, onQuickFilters: api._onQuickFilters, value: $scope.searchTerm }, $rootScope.oUser.locale, $rootScope.isDesktop).then(headerToolbar => {
      $scope.headerToolbar = headerToolbar
    })
  }

  function _onFilter (filters, hasPreFilters) {
    if (hasPreFilters) {
      return
    }

    $scope.filters = {
      ...$scope.filters,
      ...filters
    }

    WorkflowHeaderService.mergeQuickFilters($scope.filters, quickFilters)
    api._buildCalendar()
  }

  function _onQuickFilters (filter) {
    if (filter === 'assignedToMe') {
      api._handleQuickFilter('assignees')
      quickFilters.assignees = quickFilters.assignees ? null : $rootScope.oUser.id
      quickFilters.authors = null
    }

    if (filter === 'createdByMe') {
      api._handleQuickFilter('authors')
      quickFilters.authors = quickFilters.authors ? null : $rootScope.oUser.id
      quickFilters.assignees = null
    }

    if (filter === 'overdue') {
      api._handleQuickFilter('overdue')
      quickFilters.overdue = !quickFilters.overdue
    }

    api._handleChangeFilters()
  }

  function _handleQuickFilter (filter) {
    $scope.filters.overdue = !!$scope.filters.overdue

    /**
     * Por algum motivo essa função é diferente da existente em kanban.controller.js.
     * Aqui ela lida com as props de quickFilters como se todas fossem arrays, quando na verdade não vai ser sempre o caso.
     * Como não quero quebrar nada, eu vou manter a função como está, mas irei fazer um early return para o caso de filter === 'overdue'.
     */
    if (filter === 'overdue') {
      $scope.filters.overdue = !$scope.filters.overdue
      return
    }

    if (!$scope.filters[filter]) {
      $scope.filters[filter] = []
    }

    const index = $scope.filters[filter].findIndex(item => item === $rootScope.oUser.id)

    if (index === -1) {
      $scope.filters[filter].push($rootScope.oUser.id)
    } else {
      $scope.filters[filter].splice(index, 1)
    }
  }
}

export { WorkflowCalendarController }
